export default "https://chowbus-web-static.chowbus.com/_next/static/chunks/proximanova-regular-webfont-c2d1ed4087efcde00df358f894291ff1.woff2";